<template>
    <div class="animated fadeIn">
      <div class="row mb-20">
        <div class="col-12">
          <div class="font-bold mb-10">PT Running</div>
          <div class="box-mini">
            <div class="p-15 pb-0">
              <div class="row">
                <div class="col-sm-4">
                  <table>
                    <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                    <td>
                       <template v-if="getRoleId === '4' || getRoleId === '3' || getRoleId === '20' || getRoleId === '27' || getRoleId === '6' || getRoleId === '17' || paradigm_id === '15101853'">
                        <!-- <a @click="openPage('/leads/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a> -->
                      </template>
  
                    </td>
                    <td>
                        <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates" name="export_date_start" class="font-13 mr-5"></flat-pickr>
                    </td>
                    <td>
                      <a @click="exportDetail()" class="btn-primary" style="margin-left: 5px;"><i class="far fa-file-alt mr-5"></i> Detail</a>
                    </td>
                  </table>
                </div>
                <div class="col-sm-3">
                  <div class="row">
                    <div class="col-sm-4 col-form-label text-right">
                      Branch
                    </div>
                    <div class="col-sm-8">
                      <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                          <option :value="null">Please select</option>
                          <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                      </b-form-select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5 text-right">
                  <div class="search-header">
                    <div class="custom-search-container">
                      <div class="input-group custom-search">
                        <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                        <span class="icon-magnifier icon-input-custom"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="mb-0">
            <div class="p-15">
              <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="" :items="items" :fields="fields">
                <template v-slot:cell(leads_source_type)="data">
  <!--              <template slot="leads_source_type" slot-scope="data">-->
                  <span>{{ (data.item.leads_source_type) ? data.item.leads_source_type.name : '-' }}</span>
                </template>
                <template v-slot:cell(sale)="data">
  <!--              <template slot="sale" slot-scope="data">-->
                  <span>{{ (data.item.sale) ? data.item.sale.fullname : '-' }}</span>
                </template>
                <template v-slot:cell(activity)="data">
  <!--              <template slot="activity" slot-scope="data">-->
                  <b-badge v-if="data.item.leads_activity === null" variant="danger">No</b-badge>
                  <b-badge v-else variant="success">Yes</b-badge>
                </template>
  
                <template v-slot:cell(membership_status)="data">
  <!--              <template slot="activity" slot-scope="data">-->
                  <b-badge v-if="data.item.is_member == false" variant="danger">No</b-badge>
                  <b-badge v-else variant="success">Yes</b-badge>
                </template>
  
                <template v-slot:cell(status)="data">
  <!--              <template slot="status" slot-scope="data">-->
                  <template v-if="data.item.is_member == false">
                    <template v-if="data.item.isTrial == 0 || data.item.isTrial == 1">
                      <b-badge :variant="statusMembership(data.item.leads_status.name)">{{data.item.leads_status.name}}</b-badge>
                    </template>
                    <template v-else>
                        <b-badge :variant="statusMembership('miss_guest')">Miss Guest</b-badge>
                    </template>
                  </template>
                  <template v-else>
                    <b-badge :variant="statusMembership(data.item.leads_status.name)">{{data.item.leads_status.name}}</b-badge>
                  </template>
                </template>

                <template v-slot:cell(actions)="data">
                  <b-button
                    size="sm"
                    @click="showDetail(data.item, 'sessionDetailModal')"
                    class="btn-table primary mr-1">
                    <i class="far fa-eye"></i> Detail
                  </b-button>
                </template>
              </b-table>
              <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                  :total-pages="totalPage"
                  @page-changed="pageOneChanged"
                  prev-text="Prev" next-text="Next"/>
            </div>
          </div>
        </div>
      </div>

      <!-- modal detail -->
      <b-modal
        modal-class="modal-custom-for-table"
        hide-footer
        :ref="'sessionDetailModal'"
        centered
        title="Session Detail">
        <div class="row p-15">
          <div class="col-sm-4">
            <table>
              <td><a @click="exportReportDetail()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
            </table>
          </div>
        </div>
        <div class="p-15">
              <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="xl" :items="itemDetails" :fields="fieldsDetail">
                <template v-slot:cell(leads_source_type)="data">
  <!--              <template slot="leads_source_type" slot-scope="data">-->
                  <span>{{ (data.item.leads_source_type) ? data.item.leads_source_type.name : '-' }}</span>
                </template>
                <template v-slot:cell(sale)="data">
  <!--              <template slot="sale" slot-scope="data">-->
                  <span>{{ (data.item.sale) ? data.item.sale.fullname : '-' }}</span>
                </template>
                <template v-slot:cell(activity)="data">
  <!--              <template slot="activity" slot-scope="data">-->
                  <b-badge v-if="data.item.leads_activity === null" variant="danger">No</b-badge>
                  <b-badge v-else variant="success">Yes</b-badge>
                </template>
  
                <template v-slot:cell(membership_status)="data">
  <!--              <template slot="activity" slot-scope="data">-->
                  <b-badge v-if="data.item.is_member == false" variant="danger">No</b-badge>
                  <b-badge v-else variant="success">Yes</b-badge>
                </template>
  
                <template v-slot:cell(status)="data">
  <!--              <template slot="status" slot-scope="data">-->
                  <template v-if="data.item.is_member == false">
                    <template v-if="data.item.isTrial == 0 || data.item.isTrial == 1">
                      <b-badge :variant="statusMembership(data.item.leads_status.name)">{{data.item.leads_status.name}}</b-badge>
                    </template>
                    <template v-else>
                        <b-badge :variant="statusMembership('miss_guest')">Miss Guest</b-badge>
                    </template>
                  </template>
                  <template v-else>
                    <b-badge :variant="statusMembership(data.item.leads_status.name)">{{data.item.leads_status.name}}</b-badge>
                  </template>
                </template>

                <template v-slot:cell(actions)="data">
                  <b-button
                    size="sm"
                    @click="showDetail(data.item, 'sessionDetailModal')"
                    class="btn-table primary mr-1">
                    <i class="far fa-eye"></i> Detail
                  </b-button>
                </template>
              </b-table>
              <app-pagination class="pagination-custom mt-20" :current-page="1"
                  :total-pages="totalPageDetail"
                  @page-changed="pageOneChanged"
                  prev-text="Prev" next-text="Next"/>
            </div>

      </b-modal>

      <div v-if="loadingActive == true" class="loading-container">
        <div class="wrap-screen w-100 h-100">
          <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
          <div class="title-loading color-white">Loading...</div>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import { Callout } from '@coreui/vue'
  import axios from 'axios'
  import { Auth } from '@/api'
  import moment from 'moment'
  import Pagination from '@/views/component/pagination'
  
  export default {
    name: 'leads',
    components: {
      'app-pagination': Pagination
    },
    props: {
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: true
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        fields: [
          {
            key: 'trx_date',
            label: 'TRX Date',
            sortable: false
          },
          {
            key: 'trx_id',
            label: 'TRX ID',
            sortable: false
          },
          {
            key: 'club',
            label: 'Club',
            sortable: false
          },
          {
            key: 'member',
            label: 'Member',
            sortable: false
          },
          {
            key: 'pt_session',
            label: 'PT Session',
            sortable: false
          },
          {
            key: 'personal_trainer',
            label: 'Coach',
            sortable: false
          },
          {
            key: 'gross_amount',
            label: 'Gross Amount',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.gross_amount).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: false
          },
          {
            key: 'nett',
            label: 'Nett',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.nett).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: false
          },
          {
            key: 'beginning_qty',
            label: 'Beginning Qty',
            sortable: false
          },
          {
            key: 'running_qty',
            label: 'Running Qty',
            sortable: false
          },
          {
            key: 'expired_qty',
            label: 'Expired Qty',
            sortable: false
          },
          {
            key: 'adjustment_qty',
            label: 'Adjustment Qty',
            sortable: false
          },
          {
            key: 'ending_qty',
            label: 'Ending Qty',
            sortable: false
          },
          {
            key: 'beginning',
            label: 'Beginning',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.beginning).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: false
          },
          {
            key: 'running',
            label: 'Running',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.running).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: false
          },
          {
            key: 'expired',
            label: 'Expired Amount',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.expired).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: false
          },
          {
            key: 'adjustment',
            label: 'Adjustment',
            sortable: false
          },
          {
            key: 'diff_amount',
            label: 'Diff Amount',
            sortable: false,
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.diff_amount).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
          },
          {
            key: 'ending',
            label: 'Ending',
            formatter: (value, key, item) => {
              return 'Rp. ' + parseFloat(item.ending).toLocaleString('id-ID', {maximumFractionDigits:2})
            },
            sortable: false
          },
          {
            key: 'active',
            label: 'Status',
            sortable: false
          },
          {
            key: 'expired_at',
            label: 'Expired Date',
            sortable: false
          },
          {
            key: 'expired2',
            label: 'Expired 2',
            sortable: false
          },
          {
            key: 'expired3',
            label: 'Expired 3',
            sortable: false
          },
          {
            key: "actions",
            label: "Actions",
            sortable: false
          }
        ],
        fieldsDetail: [
            {
              key: 'trx_date',
              label: 'TRX DATE',
              sortable: false
            },
            {
              key: 'trx_id',
              label: 'TRX ID',
              sortable: false
            },
            {
              key: 'pt_session.name',
              label: 'PT Session',
              sortable: false
            },
            {
              key: 'personal_training.name',
              label: 'Personal Trainer',
              sortable: false
            },
            {
              key: 'pt_session_price',
              label: 'PT Session Price',
              sortable: false
            }
        ],
        loadingActive: false,
        modalShow: false,
        branch_id: null,
        dataBranch: [],
        detail_trx_id: '',
        dateWeek: '',
        items: [],
        itemDetails: [],
        get_data_transaction_leads: [],
        sortType: '',
        sortBy: '',
        searchData: '',
        currentPage: 1,
        paginationLimit: 10,
        totalPage: 0,
        totalPageDetail: 0,
        getRoleId: Auth.Session.get().paradigm_role,
        exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+((moment().year()+1) + moment().endOf('month').format('-MM-DD')),
        start_date: null,
        end_date: null,
        paradigm_id:Auth.Session.get().paradigm_id,
        // exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
        exportConfig: {
          mode: "range",
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: "d/m/y",
          defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), ((moment().year()+1) + moment().endOf('month').format('-MM-DD'))]
        }
      }
    },
    methods: {
        showDetail(item, id) {
          console.log(item)
          this.$refs[id].show();

          let dates = this.exportDates.split(' to ')
          this.getRoleId = Auth.Session.get().paradigm_role
          let end_date = dates[1] == undefined ? '' : dates[1]

          let branch = ''

          if (this.branch_id == null) {
            branch = ''
          } else {
            branch = this.branch_id
          }

          this.detail_trx_id = item.trx_id
          
          axios.get('crm/v1/finance/report/running_session_detail?page=&limit=&sorting=&start_date='+dates[0]
          +'&end_date='+end_date + '&branch_id=' + branch +'&trx_id='+item.trx_id).then(response => {
            this.itemDetails = response.data.data.rows
            this.totalPageDetail = response.data.meta.pageCount
          }).catch(error => {
            console.log('error', error)
          })
        },
        exportReportDetail() {
          let dates = this.exportDates.split(' to ')
            let url = 'crm/v1/export/finance/running_session_detail?start_date='+dates[0]+'&end_date='+dates[1]+'&trx_id='+this.detail_trx_id

            if (this.branch_id != null) {
            url += '&branch_id=' + this.branch_id
            }

            axios({
            method: 'get',
            url: url,
            responseType: 'arraybuffer'
            }).then(response => {
            let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'PT Running Session Detail Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
            link.click()
            }).catch(error => {
            console.log('error', error)
            })
        },
        exportReport() {
            let dates = this.exportDates.split(' to ')
            let url = 'crm/v1/export/finance/pt_running?start_date='+dates[0]+'&end_date='+dates[1]

            if (this.branch_id != null) {
            url += '&branch_id=' + this.branch_id
            }

            axios({
            method: 'get',
            url: url,
            responseType: 'arraybuffer'
            }).then(response => {
            let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'PT Running Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
            link.click()
            }).catch(error => {
            console.log('error', error)
            })
        },
        exportDetail() {
            this.loadingActive = true
            let dates = this.exportDates.split(' to ')
            let url = 'crm/v1/export/finance/all_running_session_detail?start_date='+dates[0]+'&end_date='+dates[1]

            if (this.branch_id != null) {
            url += '&branch_id=' + this.branch_id
            }

            axios({
            method: 'get',
            url: url,
            responseType: 'arraybuffer'
            }).then(response => {
              this.loadingActive = false
              let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'PT Running Detail Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
              link.click()
            }).catch(error => {
              this.loadingActive = false
              console.log('error', error)
            })
        },
      changeBranch(event) {
        // console.log(event)
        this.fetchData()
      },
      changeDateBooking(selectedDates, dateStr, instance) {
        if(selectedDates.length === 2){
            if(typeof selectedDates[0] === typeof selectedDates[1]){
                this.exportDates = dateStr + ' to ' + dateStr
            }else{
                this.exportDates = dateStr
            }
            if(this.exportDates.includes(" to ") === true) {
              let dates = this.exportDates.split(' to ')
              let start_date = dates[0]
              let end_date = dates[1] == undefined ? '' : dates[1]
              this.start_date = start_date
              this.end_date = end_date
              localStorage.setItem('leads_date_range', `${start_date} to ${end_date}`)
              this.fetchData()
            }
        }
      },
      pageOneChanged (pageNum) {
        let currentUrl = window.location.href
        let url = new URL(currentUrl)
        url.searchParams.set("page", pageNum)
        let newUrl = url.href
        window.history.pushState("Page","Paradigm Fitness Indonesia","?page="+pageNum)
        this.currentPage = pageNum
        this.fetchData()
      },
      sortingChanged (event) {
        this.sortBy = event.sortBy
        if (event.sortDesc === false) {
          this.sortType = 'asc'
        } else {
          this.sortType = 'desc'
        }
        this.fetchData()
      },
      enterClicked (searchEvent) {
        this.fetchData()
      },
      deleteData(event) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: true,
          showLoaderOnConfirm: false
        }).then((result) => {
          if(result.value) {
            this.$swal('Deleted', 'You successfully deleted this file', 'success')
            axios.delete('crm/v1/leads/' + event).then(response => {
              // this.$router.go()
              this.fetchData()
            }).catch(error => {
              console.log('error', error)
            })
          } else {
            this.$swal('Cancelled', 'Your file is still intact', 'info')
          }
        })
      },
      getRowCount (items) {
        return items.length
      },
      getBadge (status) {
        return status === 'Active' ? 'success'
          : status === 'Inactive' ? 'danger'
            : status === 'active' ? 'success'
              : status === 'inactive' ? 'danger' : 'primary'
      },
      statusMembership (status) {
        console.log('STATUS: ', status)
        return (status === 'Membership') ? 'success'
            : (status === 'On Progress') ? 'warning' : (status === 'miss_guest') ? 'warning' : 'danger'
      },
      statusActivity (status) {
        return (status === 'Membership') ? 'success'
            : (status === 'On Progress') ? 'warning' : 'danger'
      },
      openPage (event) {
        this.$router.push(event)
      },
      todayNumber () {
        return moment().isoWeekday()
      },
      cutTime (value) {
        return (value).slice(0, -3)
      },
      getNumberDay (value) {
        return moment(new Date(value)).isoWeekday()
      },
      parseDateTime1 (value) {
        moment.locale('en')
        return moment(new Date(value)).format('DD')
      },
      parseDateTime2 (value) {
        moment.locale('en')
        return moment(new Date(value)).format('dddd')
      },
      parseDateTime3 (value) {
        var curr = new Date
        var first = curr.getDate() - curr.getDay()
        var monthName = new Date(curr.getTime())
        moment.locale('en')
        return moment(new Date(monthName)).format('MMMM YYYY')
      },
      parseImg (value) {
        return Auth.apiUrl + 'crm/v1/img/banner/' + value
      },
      getLeadsTransaction(id) {
         axios.get("crm/v1/leads/get_transaction?leads_id=" + id)
          .then(response => {
            let res_data = response.data.data.rows
            console.warn('VANGKE: ',  res_data.length +' - ' + id)
            console.warn(res_data.length)
            if (res_data.length > 0) {
              return false
            } else {
              return true
            }
          })
          .catch(error => {
            console.log("error", error);
             return false
          });
      },
      fetchData() {
        let dates = this.exportDates.split(' to ')
        this.getRoleId = Auth.Session.get().paradigm_role
        let end_date = dates[1] == undefined ? '' : dates[1]

        let branch = ''

        if (this.branch_id == null) {
          branch = ''
        } else {
          branch = this.branch_id
        }
        
        axios.get('crm/v1/finance/report/pt_running?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +'&start_date='+dates[0]
          +'&end_date='+end_date + '&branch_id=' + branch).then(response => {
            this.items = response.data.data.rows
            this.totalPage = response.data.meta.pageCount
          }).catch(error => {
            console.log('error', error)
          })
  
        // branch
        axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    created () {
      let urlParams = new URLSearchParams(window.location.search)
      let pageParams = urlParams.get('page')
      this.currentPage = (pageParams != null) ? parseInt(pageParams) : 1
      const get_current_date = localStorage.getItem('leads_date_range')
      if (get_current_date) {
        this.exportDates = get_current_date
      }
  
      this.fetchData()
    },
    destroyed() {
      if (this.$router.currentRoute.path != '/leads/detail') {
        localStorage.removeItem('leads_date_range')
      }
    }
  }
  </script>
  